// extracted by mini-css-extract-plugin
export var leftAlign = "_c-2";
export var popper = "_c-0";
export var subtitle = "_c-1";